import { Box, Button, Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";
import React from "react";
import { NumericFormat } from "react-number-format";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";

export default function ConfiguracaoValorMinimo() {
  const service = new AuthService();
  const { enqueueSnackbar } = useSnackbar();
  const [valorMinimo, setValorMinimo] = React.useState("0.00");
  const [empresa, setEmpresa] = React.useState(null);

  const handleSave = () => {
    let json = {
      id: empresa.id,
      valorMinimo: valorMinimo,
    };

    service
      .put(`/empresa/changeOnly`, json)
      .then((retorno) => {
        let profile = JSON.parse(localStorage.getItem("_profile"));
        profile.empresa = retorno;
        localStorage.setItem("_profile", JSON.stringify(profile));

        setEmpresa(retorno);
        enqueueSnackbar("Pedido mínimo alterado com sucesso.", {
          variant: "success",
        });
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao alterar valor do pedido mínimo", {
          variant: "error",
        });
      });
  };

  React.useEffect(() => {
    service
      .get("/login/empresaLogada")
      .then((empresa) => {
        setEmpresa(empresa);
        setValorMinimo(empresa.valorMinimo);
      })
      .catch((err) => {
        console.error(err);
      });
    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <BarraTitulo title="Valor mínimo para entrega" />
      <Paper>
        <Box p={3}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              size={{
                xs: 12,
                sm: 10,
              }}
            >
              <NumericFormat
                customInput={TextField}
                label="Valor mínimo do pedido (para entrega em casa)"
                value={valorMinimo}
                onValueChange={(values) => {
                  setValorMinimo(values.value);
                }}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                fullWidth
              />
            </Grid>

            <Grid
              size={{
                xs: 12,
                sm: 2,
              }}
            >
              <Button
                fullWidth
                color="secondary"
                onClick={handleSave}
                variant="contained"
                sx={{ height: "3.5rem" }}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </React.Fragment>
  );
}
